module.exports = __webpack_public_path__ + "static/media/footer-logo.567b6ac5.webp";